import { useForm as createUseForm } from "@ant-design-vue/use";
import { notification, Modal } from "ant-design-vue";
import lodash from "lodash";
import { setIsLoading as setIsLoadingApp } from "../../../app.logic";
import i18n from "../../../i18n";
import store from "../../../store";
import { initUseForm, watchRulesChildren } from "../../../utils/form";
import { createLoading } from "../../../utils/loading";
import {
    email,
    required,
    sameWhen,
    validateError,
    hasIdCard,
    hasIdCardInUserRequest,
    thPid,
    thPidFirstCharacter,
    equalsLength,
    requiredWhen,
} from "../../../utils/validate";
import { createForm as createFormUser } from "../../app/setting/user-mgt/user/user.logic";
import { callGender, callSameAddressType, callPersonType } from "../register/register.section";
import { createConditionForm } from "./register-manager.condition";
import { createField } from "./register-manager.section";
import { openModalForm as openModalFormCheckProfile } from "../modal/modal-check-register.logic";
import { callAddressType, createForm as createFormAddress } from "../../../components/address/address.logic";

export const { isLoading, setIsLoading } = createLoading();

export const actionPrefix = "resource/v1/transaction/userRequest";

export const callUserRegisterManager = ({ form }) => store.dispatch(`resource/v1/transaction/userRequest/RegisterManager`, { data: form });

export const onClickSave = ({ data, formParams }) => {
    return data.useForm
        .validate()
        .then(() => {
            setIsLoadingApp(true);
            return callUserRegisterManager({ form: { ...data.useForm.modelRef, ...formParams } } )
                .finally(() => setIsLoadingApp(false))
                .then(() => {
                    const emailInp = data.useForm?.modelRef?.email
                    // const emailShow = emailInp.replace(emailInp.substr(1), 'xxx@xxxx')
                    data.lastPageImg = require(`../../../assets/icon/checked.svg`)
                    data.lastPageDetail = i18n.global.t("model.register.officer.lastPageResponse.detail", { email: emailInp })
                    data.current++
                });
        })
        .catch(error => {
            validateError({ error });
            data.lastPageImg = require(`../../../assets/icon/error_red_icon.svg`)
            data.lastPageDetail = i18n.global.t("model.register.officer.lastPageResponse.detailError")
            data.current++
            throw error;
        });
};

export const createForm = ({ props, data, refs }) => {
    return {
        ...createFormUser({ props, data, refs }),
        acceptCondition: null,
        addresses: [createFormAddress(), createFormAddress()],
    };
};

export const createRules = ({ props, data, refs, key }) => {
    return {
        ...createRulesTab0({ props, data, refs, key }),
        ...createRulesTab1({ props, data, refs, key }),
        ...createRulesTab3({ props, data, refs, key }),
    };
};


export const createRulesTab0 = ({ data, key }) => {
    const modelRef = data.useForm?.modelRef || data.form;
    const model = key ? lodash.get(modelRef, key) : modelRef;
    const prefix = key ? `${key}.` : "";
    const rules = {
        [`${prefix}idCard`]: [required, 
            hasIdCard({ 
                when: () => {
                    const { useForm } = data;
                    const { modelRef } = useForm;
                    const model = key ? lodash.get(modelRef, key) : modelRef;
                    return model.idCard;
                }, refPersonType: i18n.global.t("error.form.hasIdCard.person") 
            }), 
            hasIdCardInUserRequest({ 
                when: () => {
                    const { useForm } = data;
                    const { modelRef } = useForm;
                    const model = key ? lodash.get(modelRef, key) : modelRef;
                    return model.idCard;
                }, 
                refPersonType: i18n.global.t("error.form.hasIdCardUserRequest.person") 
        }), thPid, thPidFirstCharacter],
        [`${prefix}birthDate`]: [required],
        [`${prefix}expireDate`]: [required],
        [`${prefix}refNationality`]: [required],
        [`${prefix}refDepartment`]: [required],
        [`${prefix}refSubDepartment`]: [required],
        [`${prefix}refRace`]: [required],
        [`${prefix}refGender`]: [required],
        [`${prefix}refTitle`]: [required],
        [`${prefix}firstNameTh`]: [required],
        [`${prefix}positionCode`]: [required],
        [`${prefix}refSameAddressType`]: [required],
        [`${prefix}refPosition`]: [required],
        [`${prefix}refEducation`]: [required],
        [`${prefix}refMainOccupation`]: [required],
        [`${prefix}refSecondOccupation`]: [required],
        [`${prefix}lastNameTh`]: [required],
        [`${prefix}email`]: [required, email],
        [`${prefix}mobile`]: [required, equalsLength(10)],
        [`${prefix}password`]: [required],
        [`${prefix}passwordConfirm`]: [required,
            sameWhen({
                when: () => {
                    const { useForm } = data;
                    const { modelRef } = useForm;
                    const model = key ? lodash.get(modelRef, key) : modelRef;
                    return model.password === model.passwordConfirm;
                },
                keyLabel: i18n.global.t("model.user.password"),
                sameLabel: i18n.global.t("model.user.passwordConfirm")
            })
        ]
    };
    model?.addresses?.forEach((item, index) => {
        if (item.isDelete !== true) {
            rules[`${prefix}addresses.${index}.refAddressType`] = [required];
            rules[`${prefix}addresses.${index}.noTh`] = [required];
            rules[`${prefix}addresses.${index}.soiTh`] = [required];
            rules[`${prefix}addresses.${index}.roadTh`] = [required];
            rules[`${prefix}addresses.${index}.mooTh`] = [requiredWhen({ when: () => model?.addresses[index]?.refProvince?.code !== "10" })];
            rules[`${prefix}addresses.${index}.refProvince`] = [required];
            rules[`${prefix}addresses.${index}.refAmphur`] = [required];
            rules[`${prefix}addresses.${index}.refTambon`] = [required];
            rules[`${prefix}addresses.${index}.postCode`] = [required];
        }
    });
    return rules;
};

export const createRulesTab1 = ({ key }) => {
    const prefix = key ? `${key}.` : "";
    const rules = {
        [`${prefix}acceptCondition`]: [
            {
                validator: (rule, value) => {
                    if (value !== true) {
                        return Promise.reject(i18n.global.t("error.form.acceptCondition"));
                    }
                    return Promise.resolve();
                },
                trigger: "change"
            }
        ]
    };
    return rules;
};

export const createRulesTab3 = ({ data, key }) => {
    const modelRef = data.useForm?.modelRef || data.form;
    const model = key ? lodash.get(modelRef, key) : modelRef;
    const prefix = key ? `${key}.` : "";
    const rules = {};
    model?.attachmentDocs?.forEach((item, index) => {
        if (item.isDelete !== true) {
            rules[`${prefix}attachmentDocs.${index}`] = [required];
            rules[`${prefix}attachmentDocs.${index}.name`] = [required];
        }
    });
    model?.attachmentIdCards?.forEach((item, index) => {
        if (item.isDelete !== true) {
            rules[`${prefix}attachmentIdCards.${index}`] = [required];
            rules[`${prefix}attachmentIdCards.${index}.name`] = [required];
        }
    });
    model?.attachmentSignatures?.forEach((item, index) => {
        if (item.isDelete !== true) {
            rules[`${prefix}attachmentSignatures.${index}`] = [required];
            rules[`${prefix}attachmentSignatures.${index}.name`] = [required];
        }
    });
    return rules;
};

export const onNextRegister = ({  props, data, refs }) => {
    const rules0 = createRulesTab0({ props, data, refs });
    const rules1 = createRulesTab1({ props, data, refs });
    const rules3 = createRulesTab3({ props, data, refs });

    switch (data.current) {
        case 0:
          return data.useForm.validate(Object.keys(rules0)).then(() => data.current++ )
        case 1:
          return data.useForm.validate(Object.keys(rules1)).then(() => openModalFormCheckProfile({
            props: { dataProp: { form: data.useForm.modelRef } },
            onOk: () => {
                data.current++
            }
        }))
        case 2:
            return data.useForm.validate(Object.keys(rules3)).then(() => {
                return Modal.confirm({
                    title: i18n.global.t("views.register.validateRegister"),
                    autoFocusButton: "cancel",
                    onOk: () => {
                        onClickSave({ props, data, refs }).then(() => {
                            notification["success"]({ message: i18n.global.t("views.register.success") });
                        });
                    },
                });   
            })        
            .catch(() => {
                notification["error"]({ message: i18n.global.t("views.register.requiredAttachments") });
            });
      }
}

export const onPrevRegister = ({ data }) => {
    if(data.current != 0){
        data.current--
    }
}

export const loadForm = ({ props, data, refs }) => {
    setIsLoading(true);
    const { useForm } = data;
    const { modelRef } = useForm;
    let promise = Promise.resolve({ data: [modelRef] });
    return promise
        .then(page => initUseForm({ props, data, refs, page }))
        .then(() => loadDefaultForm({ props, data, refs }))
        .then(() => initUseForm({ props, data, refs, page: { data: [modelRef] } }))
        .finally(() => setIsLoading(false));
};

export const loadDefaultForm = ({ data }) => {
    const { useForm } = data;
    const { modelRef } = useForm;
    const promises = [callGender({}), callAddressType({}), callSameAddressType({}), callPersonType({})];
    return Promise.all(promises).then(arr => {
        data.genderTypes = arr[0];
        data.addressTypes = arr[1];
        data.sameAddressTypes = arr[2];
        data.personTypes = arr[3];

        modelRef.refGender = data.genderTypes?.find(d => d.key === "M");
        modelRef.refPersonType = data.personTypes?.find((d) => d.key === "2");
        modelRef.addresses[0].refAddressType = data.addressTypes?.find(d => d.key === "1");
        modelRef.addresses[0].isValue1 = false
        modelRef.addresses[1].refAddressType = data.addressTypes?.find(d => d.key === "2");
        modelRef.addresses[1].isValue1 = false
        modelRef.refSameAddressType = data.sameAddressTypes?.find(d => d.key === "2");
        data.addressPersonType = modelRef.addresses[0].refAddressType.value
        modelRef.attachmentDocs.push({})
        modelRef.attachmentIdCards.push({})
        modelRef.attachmentSignatures.push({})
    });
};

export const initForm = ({ props, data, refs }) => {
    data.current = 0;
    data.registerType = 'OFFICER';
    data.form = createForm({ props, data, refs });
    data.rules = createRules({ props, data, refs });
    data.useForm = createUseForm(data.form, data.rules);
    data.fields = createField({ props, data, refs, isLoading });
    data.conditionForms = createConditionForm({ props, data, refs, isLoading });
    loadForm({ props, data, refs });
    watchRulesChildren({
        props,
        data,
        refs,
        trigger: () => ({
        length1: data.useForm.modelRef.attachmentDocs.filter(d => d.isDelete !== true).length,
        length2: data.useForm.modelRef.attachmentIdCards.filter(d => d.isDelete !== true).length,
        length3: data.useForm.modelRef.attachmentSignatures.filter(d => d.isDelete !== true).length
        }),
        createRules: () => createRulesTab3({ props, data, refs }),
        itemsKey: ["attachmentDocs", "attachmentIdCards", "attachmentSignatures"]
    });
    watchRulesChildren({
        props,
        data,
        refs,
        trigger: () => data.useForm.modelRef.addresses.filter(d => d.isDelete !== true).length,
        createRules: () => createRulesTab0({ props, data, refs }),
        itemsKey: "addresses"
    });
};
